// Our Components
import PageHeading from 'components/PageHeading/PageHeading';
import ConfigureKeyActions from 'components/Cards/KeyActions/ConfigureKeyActions';

function KeyActionsConfigurePage() {
	return (
		<>
			<PageHeading
				title="Key Actions Configure"
				subtitleText="This page allows you to configure key action qualifiers"
			/>
			<ConfigureKeyActions />
		</>
	);
}

export default KeyActionsConfigurePage;
